import { useTranslation } from 'libs/i18n'

export const useTabs = () => {
	const { t } = useTranslation()

	return [
		{ label: t('Account'), value: 'account' },
		{ label: t('Legal'), value: 'legal' },
		{ label: t('Social'), value: 'social' },
		{ label: t('Payments'), value: 'payments' },
		{ label: t('Commissions'), value: 'commissions' },
		{ label: t('Product Registration'), value: 'productRegistration' }
	]
}
